<ng-template #assignedToPopover
  ><div [innerHtml]="assignedToUsers"></div
></ng-template>

<main class="madero-style tw-flex tw-flex-col xl:!tw-flex-row-reverse">
  <rv-draggable [draggableService]="draggableService">
    <weekly-templates></weekly-templates>
    <div class="tw-w-full">
      <div resizeObserver (resizeEvent)="onHeaderResize($event)">
        @if (error()) {
          <div
            id="errorBox"
            class="madero-style alert alert-danger text-center u_margin-md-top"
            role="alert"
          >
            <p>
              <strong>{{ error().errorMessage }}</strong>
            </p>
            {{ error().apiError }}
          </div>
        }
        <div
          class="tw-flex tw-flex-col md:!tw-flex-row tw-py-5 tw-px-[15px] tw-gap-2.5"
        >
          <search-filter
            class="tw-w-full"
            #searchFilter
            [filterConfig]="filterConfig"
            [search]="searchState.getSearchObject()"
            [doSearch]="doSearch"
            [focus]="true"
          />
          @if (canUseFolders()) {
            <new-folder-button
              [parentId]="folderId"
              [existingFiles]="folders"
              kind="Presentation"
              (folderAdded)="listService.reload()"
            ></new-folder-button>
          }
          @if (showAiButton()) {
            <a
              rv-button
              variant="secondary"
              id="presentationGenerateWithAiButton"
              class="tw-shrink-0 tw-whitespace-nowrap"
              uiSref="apps.chat"
            >
              <mat-icon
                svgIcon="ai-gradient"
                class="filled"
                aria-hidden="true"
              />
              Generate with AI
            </a>
          }
          <button
            rv-button
            type="button"
            id="presentationAddButton"
            class="tw-min-w-[200px]"
            (click)="navigateToCreatePresentation(folderId)"
          >
            <mat-icon svgIcon="add" aria-hidden="true" /> Add Presentation
          </button>
        </div>
        <batch-actions
          styles="xl:!tw-mr-72 xl:!tw-min-w-[725px]"
        ></batch-actions>
        <div
          class="tw-flex tw-flex-col tw-gap-2.5 tw-px-4 tw-border-solid tw-border-0 tw-border-t tw-border-gray-200"
        >
          <folder-path
            [folderTree]="folderService.folderPathTree"
            [folderId]="folderId"
            (folderClicked)="onFolderClicked($event)"
            rootName="Presentations"
          ></folder-path>
        </div>
      </div>
      <rv-divider />
      <div
        class="tw-px-2 presentation-list-container"
        #presentationListContainer
        rvSpinner="presentation-list-loader"
        [rvShowSpinner]="
          loadingItems() ||
          editorService.loadingPresentation ||
          templateEditorFactory.loadingPresentation
        "
      >
        <cdk-virtual-scroll-viewport
          #scrollViewport
          itemSize="68"
          appendOnly
          class="scrollable-list horizontal-scroll rounded-rows"
        >
          <table
            id="presentationListTable"
            class="table"
            aria-label="Presentations"
          >
            <thead class="table-header">
              <tr class="table-header__row u_clickable">
                <th
                  class="table-header__cell col-sm-2 table-header__cell_{{
                    field.name
                  }}"
                  *ngFor="
                    let field of tableFields | filterBy: 'renderIf' : true
                  "
                  id="tableHeader-{{ field.name }}"
                  [ariaSort]="field.name"
                  [sortBy]="searchState.getSearchObject().sortBy"
                  [reverse]="searchState.getSearchObject().reverse"
                >
                  <div
                    [class.flex-row]="field.name === 'name'"
                    [class.fixed-width]="field.name === 'name'"
                  >
                    @if (field.name === 'name') {
                      <mat-checkbox
                        id="presentations-select-all-cb"
                        (click)="$event.stopPropagation()"
                        (change)="toggleSelection()"
                        [checked]="listState.isAllSelected()"
                        [aria-label]="
                          listState.isAllSelected()
                            ? 'Deselect all'
                            : 'Select all'
                        "
                        [aria-describedby]="
                          'tableHeader-' + field.name + '-label'
                        "
                        [ariaChecked]="listState.isAllSelected()"
                        ariaCheckedElementId="presentations-select-all-cb-input"
                        *requireRole="'!ap'"
                        class="mr-2"
                        matTooltip="Bulk select"
                        matTooltipShowDelay="500"
                        matTooltipClass="menu-tooltip"
                      />
                    }
                    <div
                      id="tableHeader-{{ field.name }}-label"
                      class="u_clickable table-header-label"
                      role="button"
                      tabindex="0"
                      (keyup.enter)="sort(field)"
                      (keydown.space)="$event.preventDefault(); sort(field)"
                      (click)="sort(field)"
                    >
                      {{ field.label }}
                      @if (
                        searchState.getSearchObject().sortBy === field.name
                      ) {
                        <i
                          [attr.aria-label]="
                            searchState.getSearchObject().reverse
                              ? 'Descending order'
                              : 'Ascending order'
                          "
                          class="fa"
                          [ngClass]="{
                            'fa-caret-up':
                              !searchState.getSearchObject().reverse,
                            'fa-caret-down':
                              searchState.getSearchObject().reverse,
                          }"
                        ></i>
                      }
                    </div>
                  </div>
                </th>
                <th class="table-header__cell action-column"></th>
              </tr>
            </thead>
            <tbody class="table-body">
              @if (
                !(
                  !loadingItems() &&
                  list().length === 0 &&
                  searchState.getSearchObject().query === undefined
                )
              ) {
                <ng-container
                  *cdkVirtualFor="let listItem of list(); let idx = index"
                >
                  @if (listItem.isFolder) {
                    <tr
                      uiSref="apps.editor.list"
                      [uiParams]="{ folderId: listItem.item.id }"
                      [rvDraggableItem]="listItem.item"
                      [rvDroppableItem]="listItem.item"
                      class="table-body__row clickable"
                      [class.selected]="listItem.selected"
                    >
                      <td
                        class="table-body__cell display-name draggable-mirror-content"
                      >
                        <div
                          class="tw-flex tw-flex-row tw-items-center tw-gap-4"
                        >
                          <mat-icon
                            rv-draggable-handle
                            class="draggable-mirror-content-hidden"
                            svgIcon="drag-stroke"
                          />
                          <mat-checkbox
                            id="presentations-cb-{{ idx }}"
                            class="draggable-mirror-content-hidden"
                            (click)="onCheckboxClick($event, listItem, idx)"
                            [checked]="listItem.selected"
                            [aria-label]="
                              listItem.selected
                                ? 'Deselect folder'
                                : 'Select folder'
                            "
                            [aria-describedby]="'folder-' + listItem.item.id"
                            [ariaChecked]="listItem.selected"
                            ariaCheckedElementId="presentations-cb-{{
                              idx
                            }}-input"
                            *requireRole="'!ap'"
                            matTooltip="Bulk select"
                            matTooltipShowDelay="500"
                            matTooltipClass="menu-tooltip"
                          />
                          <div
                            class="tw-flex tw-flex-row tw-items-center tw-gap-2.5"
                          >
                            <mat-icon
                              svgIcon="folder"
                              class="tw-text-gray-500"
                            />
                            <a
                              id="folder-{{ listItem.item.id }}"
                              uiSref="apps.editor.list"
                              [uiParams]="{ folderId: listItem.item.id }"
                              (click)="$event.stopPropagation()"
                              class="madero-link tw-font-medium u_ellipsis-lg"
                            >
                              {{ listItem.item.name }}
                            </a>
                          </div>
                        </div>
                      </td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td class="table-body__cell">
                        <change-details
                          [changeDate]="listItem.item.changeDate"
                          [changedBy]="listItem.item.changedBy"
                        />
                      </td>
                      @if (
                        companyStateService.isK12Customer() ||
                        companyStateService.isHigherEdCustomer()
                      ) {
                        <td>&nbsp;</td>
                      }
                      <td class="table-body__cell action-column">
                        <operations-menu
                          [operations]="folderOperations"
                          [entityId]="listItem.item.id"
                          [listItem]="listItem"
                          id="presentation-operations-menu-{{ idx + 1 }}"
                          (operationClick)="
                            handleOperationClick($event, listItem)
                          "
                        />
                      </td>
                    </tr>
                  } @else {
                    <tr
                      [rvDraggableItem]="listItem.item"
                      [uiSref]="
                        !isHtmlPresentation(listItem.item)
                          ? 'apps.editor.workspace.artboard'
                          : 'apps.editor.templates.edit'
                      "
                      [uiParams]="{ presentationId: listItem.item.id }"
                      class="table-body__row clickable"
                      [class.selected]="listItem.selected"
                    >
                      <td class="table-body__cell draggable-mirror-content">
                        <div
                          class="tw-flex tw-flex-row tw-items-center tw-gap-4"
                        >
                          <mat-icon
                            rv-draggable-handle
                            class="draggable-mirror-content-hidden"
                            svgIcon="drag-stroke"
                          />
                          <mat-checkbox
                            id="presentations-cb-{{ idx }}"
                            class="draggable-mirror-content-hidden"
                            (click)="onCheckboxClick($event, listItem, idx)"
                            [checked]="listItem.selected"
                            [aria-label]="
                              listItem.selected
                                ? 'Deselect presentation'
                                : 'Select presentation'
                            "
                            [aria-describedby]="
                              'presentation-' + listItem.item.id
                            "
                            ariaCheckedElementId="presentations-cb-{{
                              idx
                            }}-input"
                            [ariaChecked]="listItem.selected"
                            *requireRole="'!ap'"
                            matTooltip="Bulk select"
                            matTooltipShowDelay="500"
                            matTooltipClass="menu-tooltip"
                          />
                          <a
                            id="presentation-{{ listItem.item.id }}"
                            [uiSref]="
                              !isHtmlPresentation(listItem.item)
                                ? 'apps.editor.workspace.artboard'
                                : 'apps.editor.templates.edit'
                            "
                            [uiParams]="{ presentationId: listItem.item.id }"
                            (click)="$event.stopPropagation()"
                            class="tw-font-medium u_ellipsis-lg"
                          >
                            {{ listItem.item.name }}
                          </a>
                        </div>
                      </td>
                      <td class="table-body__cell">
                        <status-badge
                          [status]="listItem.item.revisionStatusName"
                        ></status-badge>
                      </td>
                      <td class="table-body__cell tw-text-gray-700">
                        {{
                          !listItem.item.scheduleCount
                            ? 'No schedules'
                            : listItem.item.scheduleCount +
                              (listItem.item.scheduleCount === 1
                                ? ' Schedule'
                                : ' Schedules')
                        }}
                      </td>
                      <td class="table-body__cell">
                        <change-details
                          [changeDate]="listItem.item.changeDate"
                          [changedBy]="listItem.item.changedBy"
                        />
                      </td>
                      @if (
                        companyStateService.isK12Customer() ||
                        companyStateService.isHigherEdCustomer()
                      ) {
                        <td class="table-body__cell">
                          <span class="u_ellipsis-md">
                            {{
                              listItem.item.assignedUsers &&
                              listItem.item.assignedUsers.length > 0
                                ? (listItem.item.assignedUsers[0] | username)
                                : ''
                            }}
                          </span>
                          @if (
                            listItem.item.assignedUsers &&
                            listItem.item.assignedUsers.length > 1
                          ) {
                            <rv-badge
                              class="u_clickable ml-2"
                              appearance="solid"
                              color="blue"
                              size="compact"
                              [text]="
                                '+' + (listItem.item.assignedUsers.length - 1)
                              "
                              [popover]="assignedToPopover"
                              (onShown)="
                                popoverText(listItem.item.assignedUsers)
                              "
                              containerClass="madero-style"
                              outsideClick="true"
                              placement="bottom right"
                            />
                          }
                        </td>
                      }
                      <td class="table-body__cell action-column">
                        <operations-menu
                          [operations]="listOperations.operations"
                          [entityId]="listItem.item.id"
                          [listItem]="listItem"
                          id="presentation-operations-menu-{{ idx + 1 }}"
                          (operationClick)="
                            handleOperationClick($event, listItem)
                          "
                        />
                      </td>
                    </tr>
                  }
                </ng-container>
              }
              @if (!loadingItems() && list().length === 0) {
                <tr class="placeholder">
                  <td colspan="6">
                    <div
                      class="tw-flex tw-flex-col tw-items-center tw-w-full tw-mb-[50px]"
                    >
                      @if (searchState.getSearchObject().query === undefined) {
                        <img src="../images/empty-presentations.svg" />
                        <h3>Customize your first presentation</h3>
                        <p
                          class="tw-block tw-w-1/2 tw-text-center tw-text-gray-600 tw-text-wrap"
                        >
                          A presentation is the content you want to show on your
                          display. Click "Add Presentation" to choose a
                          Template, and it will automatically be saved to this
                          list.
                        </p>
                        <button
                          rv-button
                          variant="green-text"
                          id="emptyPresentationAddButton"
                          (click)="navigateToCreatePresentation()"
                        >
                          Add Presentation
                        </button>
                      } @else {
                        <no-results
                          (action)="searchFilter.reset()"
                        ></no-results>
                      }
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>
  </rv-draggable>
</main>
